import gql from 'graphql-tag';

export const query = gql`
  query Universities($eduTag: String) {
    universities(eduTag: $eduTag) {
      id
      name
      engVeryShortName
      color
    }
  }
`;

export const converter = (uni = {}) => {
  return {
    id: uni.id,
    title: uni.name,
    initials: uni.engVeryShortName,
    color: uni.color ? uni.color[0] : null,
  };
};
